<div
    *ngIf="testInfo"
    class="container"
>
    <app-page-title [title]="'Register for a One Skill Retake'"></app-page-title>
    <br />
    <div class="panel">
        <p>
            You can apply for a one skill retake for your {{testInfo.testTypeName}} Test within sixty days of the test date. You must pay a retake fee at the time of your registration. You can see the retake fee after selecting a component below and clicking Continue. There is a limit to retaking one component only. The component cannot be changed after paying for the registration.
        </p>
        <p>
            Standard cancellation and transfer policies apply to One Skill Retake registrations. View our transfer, cancellation, and retake policies.
        </p>
        <p>
            Re-evaluations will not be allowed.
        </p>
    </div>

    <div>
        <table class="table table-hover">
            <thead>
                <tr>
                    <th>Test Date</th>
                    <th>Test Type</th>
                    <th>Test Centre</th>
                    <th>Test Centre Location</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>{{testInfo.testDateTime | date: 'MMMM d, y - EEEE h:mm a'}}</td>
                    <td>{{testInfo.testTypeName}}</td>
                    <td>{{testInfo.testCentreName}}</td>
                    <td>{{testInfo.testCentreLocation}}</td>
                </tr>
            </tbody>
        </table>
    </div>

    <div
        class="row"
        *ngIf="components && components.length > 0"
    >
        <div class="col-md-12 p-0 mb-4"><span class="required fa fa-asterisk"></span> Indicates required fields.</div>
        <form
            name="order-retake-form"
            [formGroup]="oneSkillRetakeProductsForm"
        >
            <div class="col-md-6 mw-100">

                <div class="form-group mb-2">
                    <label style="margin-bottom:15px;"><strong>Select Test Component to Retake: </strong></label><span class="required fa fa-asterisk"></span>
                    <div
                        *ngFor="let component of components"
                        class="component"
                    >
                        <label class="test-components-label">
                            <input
                                type="radio"
                                (change)="onSelect($event)"
                                [value]="component.listPrice"
                                id={{component.id}}
                                name="component"
                            />
                            {{component.name}}
                        </label>
                    </div>
                </div>
                <div
                    *ngIf="!components || components.length == 0"
                    class="my-3"
                >
                    <label style="margin-bottom:15px;">No available components for retake.</label>
                </div>
            </div>
        </form>
    </div>
    <div
        *ngIf="selectedProductId && isValidReg"
        class="custom-control custom-checkbox mt-4 mb-4"
    >
        <input
            type="checkbox"
            class="custom-control-input"
            name="identityDocument-Check"
            id="identityDocument-Check"
            [(ngModel)]="identityDocumentCheck"
        >
        <label
            class="custom-control-label"
            for="identityDocument-Check"
            style="font-weight: 500; font-size: 18px;"
        >I agree to present the same identity document as registration {{regId}} on the test day for entry. <span class="required fa fa-asterisk"></span></label>
    </div>
    <div *ngIf="selectedProductId && isValidReg && identityDocumentCheck">
        <div class="row survey">
            <div class="col-md-6">
                <div class="form-group surveyQuestion">
                    <label class="questionText">1. Country</label>
                    <select
                        [(ngModel)]="countryId"
                        class="form-control"
                        name="countryId"
                    >
                        <option
                            disabled
                            *ngFor="let country of countries"
                            [value]="country.id"
                        >{{country.name}}</option>
                    </select>
                </div>
            </div>
            <div
                class="col-md-6"
                *ngIf="showRegion"
            >
                <div class="form-group surveyQuestion">
                    <label class="questionText">2. Select a region</label>
                    <select
                        [(ngModel)]="regionId"
                        (change)=getTestCentreSittings()
                        class="form-control"
                        name="region"
                    >
                        <option
                            *ngFor="let region of regions"
                            [value]="region.id"
                        >{{region.name}}</option>
                    </select>
                </div>
            </div>
        </div>
        <div
            class="row survey"
            *ngIf="cities?.length>0"
        >
            <div class="col-md-6">
                <div class="form-group surveyQuestion">
                    <label class="questionText">3. Select a city</label>
                    <select
                        [(ngModel)]="city"
                        (change)=filterSittingsByCity()
                        class="form-control"
                        name="city"
                    >
                        <option
                            disabled
                            value="null"
                        ></option>
                        <option
                            *ngFor="let city of cities"
                            [value]="city"
                        >{{city}}</option>
                    </select>
                </div>
            </div>
        </div>
        <div
            class="row survey"
            *ngIf="cities?.length>0"
        >
            <div class="col-md-6">
                <div class="form-group surveyQuestion">
                    <label class="questionText">4. Select a test sitting</label>
                    <select
                        class="form-control"
                        name="sittingId"
                        [(ngModel)]="sittingId"
                    >
                        <option
                            disabled
                            value="null"
                        ></option>
                        <option
                            *ngFor="let sitting of publicSittings"
                            [value]="sitting.id"
                        >{{sitting.testDateTimeTestCentre | date: 'EEEE, MMMM d, y, h:mm a'}} - {{sitting.testFee | currency: sitting.currencyCode : sitting.currencyCode + " "}}</option>
                    </select>
                </div>
            </div>
        </div>
    </div>
    <div
        *ngIf="showAlert && identityDocumentCheck"
        class="col-md-6 alert alert-danger"
    >
        <p> At this time, there are no test sittings available at this location.For more information, please contact our office by email at info@celpip.ca or toll-free at 1-800-958-5186.</p>
    </div>
</div>
<div class="row mt-4 mb-4">
    <div class="col-md-12">
        <a
            [routerLink]="['/my-account']"
            class="btn btn-primary m-1"
        >Back</a>
        <button
            type="button"
            class="btn btn-primary m-1"
            (click)="addOSRToCart()"
            [disabled]="!(selectedProductId && sittingId && identityDocumentCheck)"
            name="confirmationYesBtn"
        >
            <i class="fa fa-shopping-cart"></i> Continue
        </button>
    </div>
</div>

<app-modal
    #errorModal
    title="Error"
    body="{{modalBody}}"
    (clickPositive)="redirectToMyAccount()"
>
</app-modal>
